function detectDeviceType() {
  const userAgent = navigator.userAgent

  // Check for common mobile OS keywords in the User Agent
  if (/Android/i.test(userAgent) || /webOS/i.test(userAgent) || /iPhone/i.test(userAgent) || /iPad/i.test(userAgent) || /iPod/i.test(userAgent) || /BlackBerry/i.test(userAgent) || /Windows Phone/i.test(userAgent)) {
    return 'Mobile'
  } else {
    return 'Desktop'
  }
}

if (detectDeviceType() === 'Desktop' && window.innerWidth < 500) {
  document.body.classList.add('desktop-zoomed')
} 
